import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Container } from '@presentation/components';
import { mediaQuery } from '@presentation/styles';

export const QuizResultContainer = styled(Container)`
  padding-bottom: 15px;
`;
export const SideContentWrapper = styled.div`
  padding: 25px;
  position: relative;
  background: ${(props) => props.theme.color.light.default};
  border-radius: 10px;

  display: flex;
  flex-direction: column;
`;

export const CardItemWrapper = styled.div`
  padding: 15px;
  width: 50%;
  ${mediaQuery('phone')} {
    width: 100%;
  }
`;

export const HowToSubscribeHelper = styled.div`
  background-color: ${(props) => props.theme.color.purple.tint};
  color: ${(props) => props.theme.color.purple.default};
  padding: 16px;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 30px;

  svg {
    vertical-align: middle;
    margin-right: 4px;
  }
`;

export const accordionWrapperStyle = () => css`
  box-shadow: none;
`;
